<template>
  <Content @back="$router.back()" key="exportsList" style="width:1024px">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div class="btn " @click="jumpTo('/coach/list')">教练员管理</div>
        <div class="btn " @click="jumpTo('/coach/majorDomoList')">青训总监</div>
        <div class="btn active" >复合团队</div>
      </div>
    </template>
    <template v-slot:nav_right>
      <div v-if="isCanEditData" class="yioks_btn" @click="handleEmptyAction">新增复合团队人员</div>
    </template>
    <template v-slot:content_right>
      <div class="base-content-warpper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <select
                v-model="filterData.organUuid"
                class="yioks_select"
                @change="changeSelectOrg"
              >
                <option v-if="selectOrganList.length > 1" value="">
                  全部区体育行政部门
                </option>
                <option
                  v-for="item in selectOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                >
                  {{ item.organShortName }}
                </option>
              </select>
              <select
                v-model="filterData.youthUuid"
                class="yioks_select"
                @change="changeQuery(true)"
              >
                <option v-if="selectCenterList.length !== 1" value="">
                  全部培训机构
                </option>
                <option
                  v-for="item in selectCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                >
                  {{ item.youthShortName }}
                </option>
              </select>
              <select
                v-model="filterData.coachRankPhysicalType"
                class="yioks_select"
                @change="changeQuery(true)"
              >
                <option value="">体能等级</option>
                <option value="F1">体能L1</option>
                <option value="F2">体能L2</option>
              </select>
              <select
                v-model="filterData.coachTypeEnum"
                class="yioks_select"
                @change="changeQuery(true)"
              >
                <option value="">全部人员类型</option>
                <option value="PHYSICALCOACH">体能教练员</option>
                <option value="REHABILITATION">运动康复师</option>
                <option value="TEAMDOCTOR">队医</option>
                <option value="OTHER">其他（技术分析师）</option>
              </select>
              <select
                v-model="filterData.coachNature"
                class="yioks_select"
                @change="changeQuery(true)"
              >
                <option value="">全部工作类型</option>
                <option value="全职">全职</option>
                <option value="兼职">兼职</option>
              </select>
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.keyWord"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>

          <div class="list_wrap" v-if="!isShowPageLoading && pageList.length">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th unionName">单位</div>
                  <div class="th idName">姓名</div>
                  <div class="th gender">性别</div>
                  <div class="th phone">体能等级</div>
                  <div class="th type">人员类型</div>
                  <div class="th auth">年度注册</div>
                  <div class="th type">工作类型</div>
                  <div class="th action">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in pageList"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td unionName">
                          <p>{{ item.workName }}</p>
                        </div>
                        <div class="td idName">
                          <p>{{ item.idName }}</p>
                        </div>
                        <div class="td gender">
                          <p>{{ item.gender }}</p>
                        </div>
                        <div class="td phone">
                          <div style="display:block;text-align:center">
                            <p>{{ item.coachRankPhysicalType | coachClassLevel}}</p>
                            <p v-if="item.coachPhysicalLicenseEnd">{{ item.coachPhysicalLicenseEnd}}</p>
                          </div>
                        </div>

                        <div class="td type">
                          <p>{{ item.coachTypeEnum | coachTypeEnumTypeFilter}}</p>
                        </div>
                        <div class="td auth">
                          <p :class="{ coachLimit: !item.isAuthComplete }">{{ item.isAuthComplete ? '已注册':'未注册'}}</p>
                        </div>
                        <div class="td type">
                          <p>{{ item.coachNature }}</p>
                        </div>
                        <div class="td action">
                          <span class="item active" v-if="isCanEditData" @click="handleEditRow(item)">编辑</span>
                          <span class="split" v-if="isCanEditData" style="margin:0 5px">/</span>
                          <span class="item active" @click="viewInfo(item)">查看</span>
                          <span class="split" v-if="isCanEditData" style="margin:0 5px">/</span>
                          <span class="item" v-if="isCanEditData" @click="deleteSquad(item.uuid)" style="color:#f88594">删除</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <yioks-loading v-if="isShowPageLoading" />

          <yioks-empty
            v-if="!isShowPageLoading && !pageList.length"
            tips="暂时没有数据"
            :name="isCanEditData ? '，点击添加复合团队人员' : '' "
            @callback="handleEmptyAction"
          ></yioks-empty>
        </div>
      </div>
      <yioks-pagination :page.sync="page" :total="total"></yioks-pagination>
      <template v-if="isShowExpertAction">
        <expert-action
          :isShow.sync="isShowExpertAction"
          :isEdit="isEditExpert"
          :defaultInfo="editRow"
          @callback="expertActionCallback"
        >
        </expert-action>
      </template>
      <yioks-tip :showTip="showTip" tipMsg="确定删除该复合团队人员吗？" @callback='isDelete' />
      <yioks-dialog
        title="查看复合团队人员信息"
        :show-flag="isShowDialog"
        :isShowCancel="false"
        :width="'860px'"
        :successBtn="'关闭'"
        @hideDialog="hideDialogFunction"
      >
        <div class="dialog-content">
          <vue-scroll>

            <div class="info">
              <div class="col">
                <span>单位：{{showItem.workName}}</span>
                <span>人员类型：{{showItem.coachTypeEnum | coachTypeEnumTypeFilter }}</span>
              </div>
              <div class="col">
                <span>姓名：{{showItem.idName || '--'}}</span>
                <span>身份证号：<yioks-privacy-text type="idNumber" :value="showItem.idNumber" /></span>
              </div>
              <div class="col">
                <span>手机号：<yioks-privacy-text type="phone" :value="showItem.phone" /></span>
                <span>性别 ：{{showItem.gender || '--'}}</span>
              </div>
              <div class="col" v-if="showItem.classLevel">
                <span>教练等级：{{showItem.classLevel | coachClassLevel}}</span>
                <span>执照有效期：{{showItem.coachLicenseEnd || '--'}}</span>
              </div>
              <div class="col" v-if="showItem.coachRankPhysicalType">
                <span>体能教练等级：{{showItem.coachRankPhysicalType | coachClassLevel}}</span>
                <span>体能执照有效期：{{showItem.coachPhysicalLicenseEnd || '--'}}</span>
              </div>
              <div class="col" v-if="showItem.coachRankSpecialType">
                <span>守门员教练等级：{{showItem.coachRankSpecialType | coachClassLevel}}</span>
                <span>守门员执照有效期：{{showItem.coachGoalieLicenseEnd || '--'}}</span>
              </div>
              <div class="col">
                <span :class="{ coachLimit: !showItem.isAuthComplete }">是否完成年度注册：{{ showItem.isAuthComplete ? '已注册':'未注册'}}</span>
                <span>工作类型：{{showItem.coachNature}}</span>
              </div>
              <div class="col" v-if="showItem.fileUrlContract">
                <span>复合团队工作合同：
                  <a
                    :href="$yioksConfig.transferBaseOnly(showItem.fileUrlContract)"
                    target="_blank"
                    :title="showItem.fileNameContract"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                    v-if="showItem.fileUrlContract"
                  >{{ showItem.fileNameContract }}</a>
                    <a v-else>--</a>
                  </span>
                <span>复合团队社保证明：
                  <a
                    :href="$yioksConfig.transferBaseOnly(showItem.fileUrlSecurity)"
                    target="_blank"
                    :title="showItem.fileNameSecurity"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                    v-if="showItem.fileUrlSecurity"
                  >{{ showItem.fileNameSecurity }}</a>
                    <a v-else>--</a>
                  </span>
              </div>
              <div class="col" style="display:block">
                <div>
                  <span style="margin-bottom:10px">相关资质证明：
                  <a
                    :href="$yioksConfig.transferBaseOnly(showItem.fileUrl)"
                    target="_blank"
                    :title="showItem.fileName"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                    v-if="showItem.fileUrl"
                  >{{ showItem.fileName }}</a>
                  </span>
                </div>

              </div>
            </div>
          </vue-scroll>
        </div>
      </yioks-dialog>
    </template>
  </Content>
</template>

<script>
import {coachTypeEnumTypeFilter} from "@/assets/js/yioksFilters";
import { coachClassLevel } from '@/utils/yioks_filter'
import squad from "@/api/squad";
import coach from "@/api/coach";
import storage from '@/utils/storage'
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  components: {
    Content: () => import("@/components/layout/list"),
    "yioks-tips": () => import("@/components/YioksTip"),
    "expert-action": () =>
      import("@/views/coach/addTeam"),
  },
  mixins: [mixinAppConfig],
  data() {
    return {
      filterData: {
        keyWord: "",
        youthUuid: "",
        organUuid: "",
        coachTypeEnum: "",
        coachNature: "",
        coachRankPhysicalType: "",
      },
      pageList: [],
      batchOrganList: [],
      batchCenterList: [],
      selectOrganList: [],
      selectCenterList: [],
      page: 0,
      pageSize: 20,
      total: 0,
      userRole: storage.get('userInfo').userRole,
      isShowPageLoading: false,

      isShowExpertAction: false,
      batchInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        squadUuid: "",
        squadName: "",
      },
      isEditExpert: false,
      editRow: {},
      showTip: false,
      delUuid: "",
      isShowDialog: false,
      showItem: false,
    };
  },

  computed: {
    phaseUuid() {
      const { phaseUuid } = this.$route.query;
      return phaseUuid || "";
    },
  },

  filters: {
    coachTypeEnumTypeFilter,
    coachClassLevel
  },

  watch: {
    page() {
      this.changeQuery();
    },
    isShowExpertAction(val) {
      if(!val) {
        this.isEditExpert = false;
        this.editRow = {}
      }
    },
  },

  created() {
    this.setFilterData();
    this.changeQuery(true);
    this.getOrganListAndCenterList();
  },

  methods: {
    hideDialogFunction (flag, ok) {
      if (ok) {
        this.isShowDialog = flag
      } else {
        this.isShowDialog = flag
      }
    },
    viewInfo (item) {
      this.showItem = item;
      this.isShowDialog= true
    },
    deleteSquad (uuid) {
      this.showTip = true
      this.delUuid = uuid
    },
    isDelete (isSure) {
      if (isSure) {
        coach.deletCoachMajor(this.delUuid).then(res => {
          this.showTip = false
          this.changeQuery(true);
        })
      } else {
        this.showTip = false
      }
    },
    getOrganListAndCenterList() {
      let data = this.uuid;
      let request = squad.getOrgListByYouth;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
        // data = this.uuid
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      }
      request(data).then((res) => {
        // this.organList = res
        this.selectOrganList = res;
        this.batchOrganList = res;
        if (this.selectOrganList.length === 1) {
          this.$set(
            this.filterData,
            "organUuid",
            this.selectOrganList[0].organUuid
          );
          this.$set(
            this.batchInfo,
            "organUuid",
            this.batchOrganList[0].organUuid
          );
          this.$set(
            this.batchInfo,
            "organShortName",
            this.batchOrganList[0].organShortName
          );
          this.batchCenterList =
            this.batchOrganList.find((item) => {
              return item.organUuid === this.filterData.organUuid;
            }).youthList || [];
          this.selectCenterList = this.batchCenterList;
          if (this.batchCenterList.length === 1) {
            this.$set(
              this.filterData,
              "youthUuid",
              this.selectCenterList[0].uuid
            );
            this.$set(
              this.batchInfo,
              "youthUuid",
              this.batchCenterList[0].uuid
            );
            this.$set(
              this.batchInfo,
              "youthShortName",
              this.batchCenterList[0].youthShortName
            );
            this.squadList =
              this.selectCenterList.find((item) => {
                return item.uuid === this.batchInfo.youthUuid;
              }).squadList || [];
            if (this.squadList.length === 1) {
              this.batchInfo.squadUuid = this.squadList[0].uuid;
              this.batchInfo.squadShortName = this.squadList[0].shortName;
            }
          }
        }
        this.filterData.organUuid && this.setCenterList();
        // getlist()
      });
    },
    setCenterList() {
      if (this.selectCenterList.length === 0) {
        this.selectCenterList =
          this.selectOrganList.find((item) => {
            return item.organUuid === this.filterData.organUuid;
          }).youthList || [];
      }
      // this.centerList = this.batchCenterList = this.selectCenterList
    },
    jumpTo(path) {
      if(this.userRole === 'expert' || this.userRole === 'organ' ){
        this.$router.replace({
          path: path,
          query: {
            organUuid:this.filterData.organUuid,
            youthUuid:this.filterData.youthUuid,
          },
        });
      }else{
        this.$router.replace(path)
      }
    },
    goCoach(){
      this.$router.push({
        path: "list",
        query: {},
      });
    },
    goMajorDomo(){
      this.$router.push({
        path: "majorDomoList",
        query: {},
      });
    },
    handleEmptyAction() {
      this.isShowExpertAction = true;
    },

    // 弹窗回调 actionStatus弹窗按钮状态； funStatus弹窗操作结果回调
    expertActionCallback(actionStatus, funStatus) {
      if (actionStatus) {
        if (funStatus) {
          this.changeQuery(true);
        }
      }
      this.isEditExpert = false;
      this.isShowExpertAction = false;
      this.editRow = {}
    },

    // 设置参数
    setFilterData() {
      const { page,keyWord, organUuid, youthUuid } =
        this.$route.query;
      keyWord && this.$set(this.filterData, "keyWord", keyWord);
      organUuid && this.$set(this.filterData, "organUuid", organUuid);
      youthUuid && this.$set(this.filterData, "youthUuid", youthUuid);
      if (page) this.page = page;

    },
    // 管理单位切换
    changeSelectOrg() {
      this.$set(this.filterData, "youthUuid", "");
      if (this.filterData.organUuid) {
        this.selectCenterList =
          this.selectOrganList.find((item) => {
            return item.organUuid === this.filterData.organUuid;
          }).youthList || [];
        if (this.selectCenterList.length === 1) {
          this.$set(this.filterData, "youthUuid", this.selectCenterList[0].uuid);
        }
      } else {
        this.selectCenterList = [];
        this.$set(this.filterData, "youthUuid", "");
      }
      this.changeQuery(true);
    },

    // 管理单位切换
    changeOrgInAddGroup(val) {
      this.$set(this.batchInfo, "youthUuid", "");
      this.$set(this.batchInfo, "youthShortName", "");
      if (val) {
        this.batchCenterList =
          this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).youthList || [];
        this.batchInfo.organShortName = this.batchOrganList.find((item) => {
          return item.organUuid === this.batchInfo.organUuid;
        }).organShortName;
        if (this.batchCenterList.length === 1) {
          this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
          this.$set(
            this.batchInfo,
            "youthShortName",
            this.batchCenterList[0].youthShortName
          );

          this.squadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchCenterList[0].uuid;
            }).squadList || [];
        }
      } else {
        this.batchCenterList = [];
      }
    },
    // 单位切换
    changeBathCenter(val) {
      this.batchInfo.youthShortName = this.batchCenterList.find((item) => {
        return item.uuid === this.batchInfo.youthUuid;
      }).youthShortName;

      this.squadList =
        this.batchCenterList.find((item) => {
          return item.uuid === val;
        }).squadList || [];
    },
    // 预设方法
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageList();
    },

    // 加载列表请求方法
    loadPageList(flag = false) {
      // const { stageUuid } = this.$route.query;
      const paramsData = {
        page: this.page,
        size: this.pageSize,
        ...this.filterData
      };

      if (!flag) this.isShowPageLoading = true;
      let requestName = coach.getCenterCoachMajorList;

      if (requestName) {
        requestName(paramsData)
          .then((res) => {
            if (!flag) this.isShowPageLoading = false;
            if (res.code) {
              this.$msssage.error(res.msg);
              return;
            }
            const { content, totalElements } = res;
            this.total = totalElements;
            this.pageList = content;
          })
          .catch((err) => {
            this.isShowPageLoading = false;
            console.error("err", err);
          });
      } else {
        console.error("user type select error");
      }
    },

    handleEditRow(row) {
      this.editRow = row;
      this.isEditExpert = true;
      this.isShowExpertAction = true;
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
.yioks_select
  width 130px !important
.list_wrap
  flex 1
  overflow hidden
  height 470px
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
    /* flex 1 */
    /* overflow hidden */
    .tbodyWrap
      display block
    // padding: 0 40px;
    .tbody
      display block
      width 1024px
      margin-left auto
      margin-right auto
      max-width 944px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .coachLimit
      color #f88594 !important
.seq
  width 5%
.idName
  width 10%
.gender
  width 5%
.phone
  width 13%
.idNumber
  width 20%
.unionName
  width 18%
.auth
  width 10%
.type
  width 10%
.action
  // width 16%
  flex 1
  .item
    cursor pointer
    user-select none
    &.active
      color $green_color
    &.danger
      color $red_color
.dialog-content
  width 100%
  height 320px
  padding 10px 0px 20px
  .info
    flex 1
    border 1px solid #4cd964
    border-bottom: none
  .col
    border-bottom 1px solid #4cd964
    // border-right 1px solid #FFF
    padding 16px 15px
    display flex
    justify-content space-around
    span
      display inline-block
      width 100%
</style>
